import { render, staticRenderFns } from "./AccountsView.yaml?vue&type=template&id=0a27fc22&component"
import script from "./AccountsView.yaml?vue&type=script&lang=ts&component"
export * from "./AccountsView.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports